export default {"major":1,"minor":1,"revision":24,"build":548,"date":"2024-12-24T05:46:41.549Z"};